import { createGeneralSelectors } from '../_common/selectors';

const getWorkItemSlice = state => state.workItem;
export const { getById, getIds, makeGetByQuery } = createGeneralSelectors(getWorkItemSlice);
